import { render, staticRenderFns } from "./sub-tab.vue?vue&type=template&id=d7332570&scoped=true&"
import script from "./sub-tab.vue?vue&type=script&lang=js&"
export * from "./sub-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7332570",
  null
  
)

export default component.exports